// material-ui
import { useTheme } from '@mui/material/styles';

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  const theme = useTheme();

  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Apartman Yönetim Sistemi">
      <path d="M7 8L12.5 3L18 8H7Z" fill={theme.vars.palette.primary.dark} />
      <rect x="7" y="8" width="11" height="21" rx="1" fill={theme.vars.palette.primary.main} />
      <rect x="18" y="13" width="7" height="16" rx="1" fill={theme.vars.palette.primary.light} />
      <g fill={theme.vars.palette.common.white}>
        <rect x="9" y="11" width="2.2" height="2.2" rx="0.4" />
        <rect x="13.2" y="11" width="2.2" height="2.2" rx="0.4" />
        <rect x="9" y="16" width="2.2" height="2.2" rx="0.4" />
        <rect x="13.2" y="16" width="2.2" height="2.2" rx="0.4" />
        <rect x="9" y="21" width="2.2" height="2.2" rx="0.4" />
        <rect x="13.2" y="21" width="2.2" height="2.2" rx="0.4" />
        <rect x="19.7" y="16" width="1.8" height="1.8" rx="0.3" />
        <rect x="22.8" y="16" width="1.8" height="1.8" rx="0.3" />
        <rect x="19.7" y="20.3" width="1.8" height="1.8" rx="0.3" />
        <rect x="22.8" y="20.3" width="1.8" height="1.8" rx="0.3" />
        <rect x="19.7" y="24.6" width="1.8" height="1.8" rx="0.3" />
        <rect x="22.8" y="24.6" width="1.8" height="1.8" rx="0.3" />
      </g>
    </svg>
  );
}
